import axios from 'axios'
import Vue from 'vue'
import NProgress from 'nprogress'

import {authService} from '../AuthService'
import router from '../../router'
import store from '../../store'

export const coreApi = axios.create({
    baseURL: process.env.VUE_APP_BACKEND_API,
    headers: {
        'Service-Token': process.env.VUE_APP_SERVICE_TOKEN,
        Accept: 'application/json',
        'Content-Type': 'application/json',
    }
})

coreApi.interceptors.response.use(
    response => {
        NProgress.done()
        return response
    },
    error => {
        if (error.response && error.response.status === 401) {
            authService.forceLogout()
            router.push({name: 'auth'})
        }
        if (error.response && error.response.status === 403) {

        }
        if (error.response && error.response.status === 422) {

        }
        if (error.response && error.response.status >= 500) {

        }
        const message = error.response.data.Message

        Vue.notify({
            group: 'mgs',
            type: 'error',
            title: message || 'Что то произошло на сервере. Пожалуйста обратитесь администратору системы.',
        })

        NProgress.done()
        return {}
    }
)

coreApi.interceptors.request.use(config => {
    NProgress.start()
    if (!store.getters['validation/isEmpty']) store.commit('validations/CLEAR_ERRORS')
    return config
})
